import { useSyncExternalStore } from "react";

const COOKIE_KEY = "logged-in";

const listeners = new Set<() => void>();

function emit() {
    for (const listener of listeners) listener();
}

function subscribe(onStoreChange: () => void) {
    listeners.add(onStoreChange);
    return () => {
        listeners.delete(onStoreChange);
    };
}

function getCookie(name: string) {
    const prefix = `${encodeURIComponent(name)}=`;
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
        if (cookie.startsWith(prefix)) {
            return decodeURIComponent(cookie.slice(prefix.length));
        }
    }
    return null;
}

function getLoggedIn() {
    return getCookie(COOKIE_KEY) === "1";
}

export function notifyLoggedInChanged() {
    emit();
}

export function useIsLoggedIn() {
    return useSyncExternalStore(subscribe, getLoggedIn, () => false);
}
